import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import JsonLd from '../../components/base/JsonLd';

export default function HomePage() {
  const [scrollY, setScrollY] = useState(0);
  const [isNavFixed, setIsNavFixed] = useState(false);
  const [activeTestimony, setActiveTestimony] = useState(0);
  const [selectedProject, setSelectedProject] = useState<number | null>(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [messageLength, setMessageLength] = useState(0);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setScrollY(scrollPosition);
      setIsNavFixed(scrollPosition > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimony((prev) => (prev + 1) % 3);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // 關閉手機選單當路由改變時
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [mobileMenuOpen]);

  const testimonials = [
    {
      project: '台中司法大廈外墻塗裝工程',
      quote: '專業的施工團隊,精確的工藝標準,讓建築外觀歷久彌新。',
      client: '公共工程管理處',
    },
    {
      project: '桃園國際機場庫房塗裝',
      quote: '在嚴格的時程要求下,仍保持卓越的施工品質。',
      client: '機場工務管理單位',
    },
    {
      project: '璞園建設住宅專案',
      quote: '細膩的工藝與用心的服務,打造建築的永恆之美。',
      client: '璞園建設',
    },
  ];

  const projects = [
    {
      name: '中壢頤親園',
      category: '公共工程',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/74de3b02052837a5bf8174d286647159.jpeg',
      year: '2025',
      gallery: [
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/74de3b02052837a5bf8174d286647159.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/565d464d18299bbba81250da54c627f4.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/d5b33f9fdde65ec330a1415376243906.jpeg',
      ],
    },
    {
      name: '八德陳公館',
      category: '室內',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/a13cc910bcbbdd945413eb24f871b32c.jpeg',
      year: '2017',
      gallery: [
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/91552b14d64ad7c42822fe4d915e9bc9.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/60c5a241fedf79fecd5d518b69c01c5e.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/f14995528269bc6533e6e3ada1a25a9e.jpeg',
      ],
    },
    {
      name: '雲林私人案',
      category: '住宅建案',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/67a1f9efb11121f2944a0298f000b17e.jpeg',
      year: '2013',
      gallery: [
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/67a1f9efb11121f2944a0298f000b17e.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/0c25d8280bf119ef77b14c8c3c5a3baf.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/dd07c48898070a5db4f390c5cc052680.jpeg',
      ],
    },
    {
      name: '桃園藝文特區',
      category: '住宅建案',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/51f109a1b747cd151c64c7a5f8a37d60.jpeg',
      year: '2017',
      gallery: [
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/d9eea9ee8709b3916e888729bdc2bb3f.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/07ef7f4f7c4dc43b14687ad8abff8516.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/574c23517caafbd9e959ae6b5defd60c.jpeg',
      ],
    },
    {
      name: '內湖區住宅',
      category: '住宅建案',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/30e5245b1d51d34cd4f05f72018cf6bd.jpeg',
      year: '2025',
      gallery: [
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/f9e90ae4c969078e4ee65bede232977d.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/30e5245b1d51d34cd4f05f72018cf6bd.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/0694ae9f4a20494fc882df0ae6c1454d.jpeg',
      ],
    },
    {
      name: '信義區住宅',
      category: '住宅建案',
      image: 'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/3629e0c1c3a858051259ee6af84350b4.png',
      year: '2025',
      gallery: [
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/3629e0c1c3a858051259ee6af84350b4.png',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/cebcae95e2fda5fae3393feb5d7626b8.jpeg',
        'https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/ea530072ec7683741d3a795e1acaa1a6.jpeg',
      ],
    },
  ];

  const layers = [
    {
      title: '底塗層介面',
      subtitle: '深層防護系統',
      description: '深層滲透混凝土毛細孔,形成完整的接著屏障。有效阻隔水氣侵蝕,保護建築結構不受潮濕損害。',
      features: ['深層滲透技術', '完整防水屏障', '抗鹽害處理', '長效防護'],
      color: 'bg-[#34495E]',
      icon: 'ri-shield-check-line',
    },
    {
      title: '中塗層紋理',
      subtitle: '多重保護層',
      description: '多層交叉塗佈工法,增強塗層附著力與彈性,有效抵抗建築物的微幅震動與溫度變化。',
      features: ['多重保護層', '交叉塗佈技術', '彈性增強', '震動抵禦'],
      color: 'bg-[#D4AF37]',
      icon: 'ri-hammer-line',
    },
    {
      title: '面層抗UV',
      subtitle: '持久亮麗效果',
      description: '高耐候型矽酸樹脂塗料,抗紫外線、耐酸鹼,讓建築在烈日與風雨之中,依然亮麗如新。',
      features: ['高耐候塗料', '抗紫外線處理', '耐酸鹼性', '持久亮麗'],
      color: 'bg-[#D4AF37]',
      icon: 'ri-sun-line',
    },
  ];

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const message = (form.elements.namedItem('message') as HTMLTextAreaElement)?.value || '';
    if (message.length > 500) return;

    setFormStatus('submitting');
    const formData = new URLSearchParams();
    const elements = form.elements;
    for (let i = 0; i < elements.length; i++) {
      const el = elements[i] as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
      if (!el.name) continue;
      if (el.tagName === 'SELECT') {
        formData.append(el.name, (el as HTMLSelectElement).options[(el as HTMLSelectElement).selectedIndex]?.text || el.value);
      } else {
        formData.append(el.name, el.value);
      }
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d7cq7qum3fsfopf23i20', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      if (res.ok) {
        setFormStatus('success');
        form.reset();
        setMessageLength(0);
      } else {
        setFormStatus('error');
      }
    } catch {
      setFormStatus('error');
    }
  };

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://donghua-painting.com';

  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': `${siteUrl}/#website`,
        url: `${siteUrl}/`,
        name: '東樺建築塗裝',
        description: '台灣專業建築外牆塗裝，20年經驗，築於信任繪於精緻',
        inLanguage: 'zh-TW',
      },
      {
        '@type': 'LocalBusiness',
        '@id': `${siteUrl}/#business`,
        name: '東樺建築塗裝有限公司',
        description: '專業建築外牆塗裝服務，20年經驗，採用德日進口塗料，提供防水工程、外牆翻新、塗裝維護等服務',
        url: `${siteUrl}/`,
        telephone: '03-3900-250',
        email: ['tunghua69566488@gmail.com', 'sales@tung-hua.com'],
        foundingDate: '2005',
        priceRange: '$$',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '中正二街2號',
          addressLocality: '八德區',
          addressRegion: '桃園市',
          postalCode: '334',
          addressCountry: 'TW',
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: '24.9423',
          longitude: '121.3053',
        },
        areaServed: [
          { '@type': 'Country', name: '台灣' },
        ],
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: '建築塗裝服務',
          itemListElement: [
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '建築外牆塗裝' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '防水工程' } },
            { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '外牆翻新' } },
          ],
        },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-white">
      <JsonLd id="home-jsonld" data={homeJsonLd} />
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isNavFixed ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/d57786512cad84463bdc66c219dc39c4.png"
              alt="東樺建築塗裝"
              className="h-12"
            />
          </Link>
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isNavFixed ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}
            >
              首頁
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isNavFixed ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}
            >
              關於東樺
            </Link>
            <Link
              to="/technology"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isNavFixed ? 'text-gray-900 hover:text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'
              }`}
            >
              專業工藝
            </Link>
            <a
              href="#contact"
              className="bg-[#D4AF37] text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-[#B8941F] transition-colors whitespace-nowrap cursor-pointer"
            >
              聯絡我們
            </a>
          </div>
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-8 h-8 flex flex-col items-center justify-center space-y-1.5 cursor-pointer relative z-50"
          >
            <span className={`block w-6 h-0.5 transition-all duration-300 ${mobileMenuOpen ? 'bg-gray-900 rotate-45 translate-y-2' : isNavFixed ? 'bg-gray-900' : 'bg-white'}`}></span>
            <span className={`block w-6 h-0.5 transition-all duration-300 ${mobileMenuOpen ? 'opacity-0' : isNavFixed ? 'bg-gray-900' : 'bg-white'}`}></span>
            <span className={`block w-6 h-0.5 transition-all duration-300 ${mobileMenuOpen ? 'bg-gray-900 -rotate-45 -translate-y-2' : isNavFixed ? 'bg-gray-900' : 'bg-white'}`}></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div 
        className={`fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity duration-300 ${mobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
        onClick={() => setMobileMenuOpen(false)}
      ></div>

      {/* Mobile Menu Panel */}
      <div 
        className={`fixed top-0 right-0 h-full w-72 bg-white z-40 md:hidden transform transition-transform duration-300 ease-out shadow-2xl ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="pt-24 px-6">
          <div className="space-y-1">
            <Link
              to="/"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-4 px-4 text-gray-900 font-medium hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] rounded-lg transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <i className="ri-home-4-line text-xl"></i>
                首頁
              </div>
            </Link>
            <Link
              to="/about"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-4 px-4 text-gray-900 font-medium hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] rounded-lg transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <i className="ri-building-2-line text-xl"></i>
                關於東樺
              </div>
            </Link>
            <Link
              to="/technology"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-4 px-4 text-gray-900 font-medium hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] rounded-lg transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <i className="ri-tools-line text-xl"></i>
                專業工藝
              </div>
            </Link>
            <Link
              to="/projects"
              onClick={() => setMobileMenuOpen(false)}
              className="block py-4 px-4 text-gray-900 font-medium hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] rounded-lg transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <i className="ri-gallery-line text-xl"></i>
                工程實績
              </div>
            </Link>
          </div>

          <div className="mt-8 pt-8 border-t border-gray-100">
            <a
              href="#contact"
              onClick={() => setMobileMenuOpen(false)}
              className="block w-full bg-[#D4AF37] text-white py-4 rounded-full text-center font-medium hover:bg-[#B8941F] transition-colors cursor-pointer whitespace-nowrap"
            >
              聯絡我們
            </a>
          </div>

          <div className="mt-8 space-y-4 text-sm text-gray-500">
            <div className="flex items-center gap-3">
              <i className="ri-phone-line text-[#D4AF37]"></i>
              03-3900-250
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-mail-line text-[#D4AF37]"></i>
              tunghua69566488@gmail.com
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-mail-line text-[#D4AF37]"></i>
              sales@tung-hua.com
            </div>
          </div>

          <div className="mt-8 flex gap-3">
            <a
              href="#"
              className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] hover:text-white text-[#D4AF37] transition-all cursor-pointer"
            >
              <i className="ri-facebook-fill"></i>
            </a>
            <a
              href="#"
              className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] hover:text-white text-[#D4AF37] transition-all cursor-pointer"
            >
              <i className="ri-line-fill"></i>
            </a>
            <a
              href="#"
              className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] hover:text-white text-[#D4AF37] transition-all cursor-pointer"
            >
              <i className="ri-instagram-line"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative h-screen w-full overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/89b53970397995d230342fba4b407b1d.jpg"
            alt="城市天際線"
            className="w-full h-full object-cover object-top"
            style={{ transform: `translateY(${scrollY * 0.5}px)` }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
        </div>

        <div className="relative h-full flex items-center">
          <div className="max-w-7xl mx-auto px-6 w-full">
            <div className="max-w-3xl">
              <h1 className="text-7xl md:text-8xl font-bold text-[#D4AF37] mb-6 leading-tight tracking-wider">
                築於信任
                <br />
                繪於精緻
              </h1>
              <p className="text-2xl md:text-3xl text-white/90 mb-8 font-light leading-relaxed">
                用塗料書寫城市的故事
              </p>
              <div className="h-0.5 w-32 bg-[#D4AF37] mb-8"></div>
              <p className="text-lg text-white/80 mb-12 max-w-2xl leading-relaxed">
                在鋼筋與混凝土之間,東樺為城市披上最堅實的外衣。<br />
                二十年專注建築外牆塗裝,以科學的態度與細膩的手工,守護每一座建築的生命。
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="#projects"
                  className="bg-[#D4AF37] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#B8941F] transition-all hover:shadow-2xl cursor-pointer whitespace-nowrap"
                >
                  探索工程實績
                </a>
                <a
                  href="#video"
                  className="border-2 border-white text-white px-8 py-4 rounded-full text-base font-medium hover:bg-white hover:text-gray-900 transition-all cursor-pointer whitespace-nowrap"
                >
                  觀看品牌影片
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 flex flex-col items-center animate-bounce">
          <div className="w-0.5 h-16 bg-[#D4AF37] mb-2"></div>
          <i className="ri-arrow-down-line text-2xl text-[#D4AF37]"></i>
        </div>
      </section>

      {/* About Summary */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div>
              <div className="inline-block px-4 py-2 bg-[#D4AF37]/10 rounded-full text-[#D4AF37] text-sm font-medium mb-6">
                關於東樺
              </div>
              <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
                城市的肌膚
                <br />
                <span className="text-[#D4AF37]">信任的顏色</span>
              </h2>
              <div className="space-y-6 text-gray-600 leading-relaxed text-base">
                <p>
                  自2005年創立以來,東樺建築塗裝始終堅持「品質第一、誠信為本」的經營理念。我們不僅是塗裝工程的執行者,更是建築生命週期的守護者。
                </p>
                <p>
                  從公共建築到教育機構,從科技廠房到住宅建案,每一次的塗裝都是對品質的承諾,每一道工序都是對信譽的堅守。我們相信,建築的美不僅在於設計,更在於時間的考驗。
                </p>
                <p className="text-lg font-medium text-gray-900">
                  二十年的專業積累,數百座建築的榮耀印記。
                </p>
              </div>
              <Link
                to="/about"
                className="inline-flex items-center mt-8 text-[#D4AF37] font-medium hover:gap-3 gap-2 transition-all cursor-pointer"
              >
                了解更多關於我們
                <i className="ri-arrow-right-line text-xl"></i>
              </Link>
            </div>
            <div className="relative">
              <div className="aspect-[4/3] w-full h-full relative overflow-hidden rounded-2xl">
                <img
                  src="https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/d23ee039914a4dc6c6414a9383ae6cc7.png"
                  alt="專業施工"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-8 -right-8 bg-[#34495E] text-white p-8 rounded-2xl shadow-2xl">
                <div className="text-5xl font-bold text-[#D4AF37] mb-2">20+</div>
                <div className="text-sm">年專業經驗</div>
              </div>
              <div className="absolute -top-8 -left-8 bg-white p-8 rounded-2xl shadow-2xl">
                <div className="text-5xl font-bold text-[#34495E] mb-2">500+</div>
                <div className="text-sm text-gray-600">完工案件</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Preview */}
      <section className="py-24 bg-gradient-to-br from-[#F8F9FA] to-[#E8E9EB]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-white rounded-full text-[#34495E] text-sm font-medium mb-6 shadow-md">
              專業工藝
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">
              不只是表面的色彩
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              更是結構與保護的技術結晶
            </p>
          </div>

          {/* 上排三張卡片 */}
          <div className="grid md:grid-cols-3 gap-6 mb-6">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-3xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">底塗層介面</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                深層滲透混凝土毛細孔,形成完整的接著屏障。有效阻隔水氣侵蝕,保護建築結構不受潮濕損害。
              </p>
              <div className="flex items-center text-[#D4AF37] font-medium text-sm cursor-pointer">
                了解詳情
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="w-16 h-16 bg-[#34495E]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-hammer-line text-3xl text-[#34495E]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">中塗層紋理</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                多層交叉塗佈工法,增強塗層附著力與彈性,有效抵抗建築物的微幅震動與溫度變化。
              </p>
              <div className="flex items-center text-[#D4AF37] font-medium text-sm cursor-pointer">
                了解詳情
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2">
              <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-sun-line text-3xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">面層抗UV</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                高耐候型矽酸樹脂塗料,抗紫外線、耐酸鹼,讓建築在烈日與風雨之中,依然亮麗如新。
              </p>
              <div className="flex items-center text-[#D4AF37] font-medium text-sm cursor-pointer">
                了解詳情
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>
          </div>

          {/* 下排兩張卡片居中 */}
          <div className="flex justify-center gap-6">
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 w-full md:w-[calc(33.333%-8px)]">
              <div className="w-16 h-16 bg-[#34495E]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-links-line text-3xl text-[#34495E]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">異材質介面接著</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                採用優質丙烯酸合成樹脂乳液精緻而成，能有效與磁磚表面達到最佳附著性，是舊建築物翻新表面的首選材料。
              </p>
              <div className="flex items-center text-[#D4AF37] font-medium text-sm cursor-pointer">
                了解詳情
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 w-full md:w-[calc(33.333%-8px)]">
              <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-equalizer-line text-3xl text-[#D4AF37]"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">微整平塗料</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                單組份系統，具有填充效果及強度高的粘結性，有效達到表面平整。
              </p>
              <div className="flex items-center text-[#D4AF37] font-medium text-sm cursor-pointer">
                了解詳情
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/technology"
              className="inline-block bg-[#34495E] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#2C3E50] transition-all cursor-pointer whitespace-nowrap"
            >
              探索完整工藝流程
            </Link>
          </div>
        </div>
      </section>

      {/* Projects Showcase */}
      <section id="projects" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#D4AF37]/10 rounded-full text-[#D4AF37] text-sm font-medium mb-6">
              工程實績
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">
              一座座建築
              <br />
              是我們榮耀的印記
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              從公共建築到教育機構,從科技廠房到住宅建案,遍佈全台的工程實績見證我們的專業與用心
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <div
                key={index}
                onClick={() => setSelectedProject(index)}
                className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all cursor-pointer"
              >
                <div className="aspect-[4/3] w-full h-full overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent opacity-100"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-medium mb-3">
                    {project.category}
                  </div>
                  <h3 className="text-xl font-bold mb-2">{project.name}</h3>
                  <div className="text-sm text-white/80">完工年份: {project.year}</div>
                </div>
                <div className="absolute top-4 right-4 w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-image-line text-white text-lg"></i>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/projects"
              className="inline-block bg-[#D4AF37] text-white px-8 py-4 rounded-full text-base font-medium hover:bg-[#B8941F] transition-all cursor-pointer whitespace-nowrap"
            >
              查看更多案例
            </Link>
          </div>
        </div>
      </section>

      {/* Project Gallery Modal */}
      {selectedProject !== null && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setSelectedProject(null)}
        >
          <button
            onClick={() => setSelectedProject(null)}
            className="absolute top-6 right-6 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer z-10"
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>

          <div
            className="max-w-6xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center mb-8">
              <div className="inline-block px-4 py-2 bg-[#D4AF37]/20 backdrop-blur-sm rounded-full text-[#D4AF37] text-sm font-medium mb-4">
                {projects[selectedProject].category}
              </div>
              <h3 className="text-4xl font-bold text-white mb-2">
                {projects[selectedProject].name}
              </h3>
              <p className="text-white/60">完工年份: {projects[selectedProject].year}</p>
            </div>

            <div className="grid md:grid-cols-3 gap-4">
              {projects[selectedProject].gallery.map((image, imgIndex) => (
                <div
                  key={imgIndex}
                  className="aspect-[4/3] overflow-hidden rounded-xl bg-black/30"
                >
                  <img
                    src={image}
                    alt={`${projects[selectedProject].name} - 照片 ${imgIndex + 1}`}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                  />
                </div>
              ))}
            </div>

            <div className="text-center mt-8">
              <p className="text-white/60 text-sm">點擊任意處關閉</p>
            </div>
          </div>
        </div>
      )}

      {/* Video Section */}
      <section id="video" className="py-24 bg-[#34495E]">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold text-white mb-6">品牌故事影片</h2>
            <p className="text-xl text-white/80 leading-relaxed">
              透過影像,感受東樺二十年來對建築美學的堅持與追求
            </p>
          </div>
          <div className="aspect-video bg-black/30 rounded-2xl flex items-center justify-center backdrop-blur-sm border-2 border-white/20">
            <div className="text-center">
              <div 
                onClick={() => setShowVideoModal(true)}
                className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4 hover:bg-white/30 transition-all cursor-pointer"
              >
                <i className="ri-play-fill text-4xl text-white"></i>
              </div>
              <p className="text-white/80">點擊播放品牌影片</p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Modal */}
      {showVideoModal && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4 animate-fadeIn"
          onClick={() => setShowVideoModal(false)}
        >
          <button
            onClick={() => setShowVideoModal(false)}
            className="absolute top-6 right-6 w-12 h-12 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 transition-all cursor-pointer z-10"
          >
            <i className="ri-close-line text-white text-2xl"></i>
          </button>

          <div
            className="max-w-6xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center mb-8">
              <h3 className="text-4xl font-bold text-white mb-4">
                東樺建築塗裝 · 品牌形象影片
              </h3>
              <p className="text-white/60 text-lg">築於信任，繪於精緻 — 用塗料書寫城市的故事</p>
            </div>

            <div className="aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/nKJwzpE8o6w"
                title="東樺建築塗裝品牌影片"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div className="text-center mt-8">
              <p className="text-white/60 text-sm">點擊任意處關閉</p>
            </div>
          </div>
        </div>
      )}

      {/* Testimonials */}
      <section className="py-24 bg-gradient-to-br from-[#F8F9FA] to-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-[#34495E]/10 rounded-full text-[#34495E] text-sm font-medium mb-6">
              客戶見證
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6">專業與信任的證明</h2>
          </div>

          <div className="relative bg-white rounded-2xl shadow-xl p-12">
            <div className="absolute top-8 left-8 text-6xl text-[#D4AF37]/20">
              <i className="ri-double-quotes-l"></i>
            </div>
            <div className="relative">
              <p className="text-2xl text-gray-700 mb-8 leading-relaxed text-center">
                {testimonials[activeTestimony].quote}
              </p>
              <div className="text-center">
                <div className="text-lg font-bold text-gray-900 mb-1">
                  {testimonials[activeTestimony].project}
                </div>
                <div className="text-sm text-gray-500">{testimonials[activeTestimony].client}</div>
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-8">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTestimony(index)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    index === activeTestimony ? 'bg-[#D4AF37] w-8' : 'bg-gray-300'
                  }`}
                  aria-label={`查看見證 ${index + 1}`}
                ></button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-24 bg-[#34495E]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-12">
            <div className="text-center">
              <div className="text-6xl font-bold text-[#D4AF37] mb-4">20+</div>
              <div className="text-lg text-white/80">年專業經驗</div>
            </div>
            <div className="text-center">
              <div className="text-6xl font-bold text-[#D4AF37] mb-4">500+</div>
              <div className="text-lg text-white/80">完工案件</div>
            </div>
            <div className="text-center">
              <div className="text-6xl font-bold text-[#D4AF37] mb-4">10+</div>
              <div className="text-lg text-white/80">專業團隊</div>
            </div>
            <div className="text-center">
              <div className="text-6xl font-bold text-[#D4AF37] mb-4">100%</div>
              <div className="text-lg text-white/80">客戶滿意</div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-16">
            <div>
              <div className="inline-block px-4 py-2 bg-[#D4AF37]/10 rounded-full text-[#D4AF37] text-sm font-medium mb-6">
                聯絡我們
              </div>
              <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
                開始您的
                <br />
                建築美學之旅
              </h2>
              <p className="text-lg text-gray-600 mb-12 leading-relaxed">
                無論是新建工程或是老屋翻新,我們都能為您提供最專業的塗裝解決方案。立即聯繫我們,讓專業團隊為您服務。
              </p>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl text-[#D4AF37]"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500 mb-1">聯絡電話</div>
                    <div className="text-lg font-medium text-gray-900">03-3900-250</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl text-[#D4AF37]"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500 mb-1">電子郵件</div>
                    <div className="text-lg font-medium text-gray-900">tunghua69566488@gmail.com</div>
                    <div className="text-lg font-medium text-gray-900">sales@tung-hua.com</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-[#D4AF37]"></i>
                  </div>
                  <div>
                    <div className="text-sm text-gray-500 mb-1">公司地址</div>
                    <div className="text-lg font-medium text-gray-900">台灣 334桃園市八德區中正二街2號</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#F8F9FA] to-[#E8E9EB] rounded-2xl p-8">
              {formStatus === 'success' ? (
                <div className="flex flex-col items-center justify-center py-16 text-center">
                  <div className="w-20 h-20 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-check-line text-4xl text-[#D4AF37]"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">諮詢已送出！</h3>
                  <p className="text-gray-600 mb-8 leading-relaxed">
                    感謝您的聯繫，我們的專業團隊將在 1-2 個工作天內與您聯絡。
                  </p>
                  <button
                    onClick={() => setFormStatus('idle')}
                    className="bg-[#D4AF37] text-white px-8 py-3 rounded-full font-medium hover:bg-[#B8941F] transition-all cursor-pointer whitespace-nowrap"
                  >
                    再次諮詢
                  </button>
                </div>
              ) : (
                <form
                  ref={formRef}
                  data-readdy-form
                  onSubmit={handleFormSubmit}
                  className="space-y-5"
                >
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        姓名 <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        required
                        className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors text-sm"
                        placeholder="請輸入姓名"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        聯絡電話 <span className="text-red-400">*</span>
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        required
                        className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors text-sm"
                        placeholder="請輸入電話"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      電子郵件
                    </label>
                    <input
                      type="email"
                      name="email"
                      className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors text-sm"
                      placeholder="請輸入電子郵件"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      服務類型 <span className="text-red-400">*</span>
                    </label>
                    <div className="relative">
                      <select
                        name="service_type"
                        required
                        className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors text-sm appearance-none cursor-pointer"
                      >
                        <option value="">請選擇服務類型</option>
                        <option value="exterior_painting">外牆塗裝</option>
                        <option value="waterproofing">防水工程</option>
                        <option value="renovation">老屋翻新</option>
                        <option value="interior_painting">室內塗裝</option>
                        <option value="public_works">公共工程</option>
                        <option value="other">其他服務</option>
                      </select>
                      <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
                        <i className="ri-arrow-down-s-line text-[#D4AF37]"></i>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      工程地址
                    </label>
                    <input
                      type="text"
                      name="project_address"
                      className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors text-sm"
                      placeholder="請輸入工程地址（縣市、區域即可）"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      預算範圍
                    </label>
                    <div className="relative">
                      <select
                        name="budget_range"
                        className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors text-sm appearance-none cursor-pointer"
                      >
                        <option value="">請選擇預算範圍</option>
                        <option value="under_100k">10萬以下</option>
                        <option value="100k_300k">10萬 - 30萬</option>
                        <option value="300k_500k">30萬 - 50萬</option>
                        <option value="500k_1m">50萬 - 100萬</option>
                        <option value="over_1m">100萬以上</option>
                        <option value="unknown">尚未確定</option>
                      </select>
                      <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
                        <i className="ri-arrow-down-s-line text-[#D4AF37]"></i>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      諮詢內容
                    </label>
                    <textarea
                      name="message"
                      rows={3}
                      maxLength={500}
                      onChange={(e) => setMessageLength(e.target.value.length)}
                      className="w-full px-4 py-3 border-b-2 border-[#D4AF37] bg-transparent focus:outline-none focus:border-[#B8941F] transition-colors resize-none text-sm"
                      placeholder="請描述您的需求，例如建築類型、面積、特殊要求等..."
                    ></textarea>
                    <div className="text-right text-xs text-gray-400 mt-1">{messageLength}/500</div>
                  </div>

                  {formStatus === 'error' && (
                    <div className="flex items-center gap-2 text-red-500 text-sm bg-red-50 px-4 py-3 rounded-lg">
                      <i className="ri-error-warning-line"></i>
                      送出失敗，請稍後再試或直接來電聯繫我們。
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={formStatus === 'submitting' || messageLength > 500}
                    className="w-full bg-[#D4AF37] text-white py-4 rounded-full font-medium hover:bg-[#B8941F] transition-all cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {formStatus === 'submitting' ? (
                      <>
                        <i className="ri-loader-4-line animate-spin"></i>
                        送出中...
                      </>
                    ) : '送出諮詢'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A1A1A] text-white">
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h3 className="text-4xl font-bold text-[#D4AF37] mb-4 tracking-wider">
              專業塗裝 · 誠信永續 · 築出永恆的風景
            </h3>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 py-12">
            <div className="grid md:grid-cols-4 gap-12">
              <div>
                <img
                  src="https://static.readdy.ai/image/67a293e5c2736117b5bb4e6bdb5ab7d5/d57786512cad84463bdc66c219dc39c4.png"
                  alt="東樺建築塗裝"
                  className="h-12 mb-4"
                />
                <p className="text-white/60 text-sm leading-relaxed">
                  二十年專注建築外牆塗裝,以專業工藝守護每一座建築的生命。
                </p>
              </div>

              <div>
                <h4 className="text-lg font-bold mb-4">快速連結</h4>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/"
                      className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer"
                    >
                      首頁
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/about"
                      className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer"
                    >
                      關於東樺
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/technology"
                      className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer"
                    >
                      專業工藝
                    </Link>
                  </li>
                  <li>
                    <a
                      href="#contact"
                      className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm cursor-pointer"
                    >
                      聯絡我們
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-lg font-bold mb-4">聯絡資訊</h4>
                <ul className="space-y-2 text-sm">
                  <li className="flex items-center gap-3">
                    <i className="ri-phone-line"></i>
                    03-3900-250
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="ri-mail-line"></i>
                    tunghua69566488@gmail.com
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="ri-mail-line"></i>
                    sales@tung-hua.com
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="ri-map-pin-line"></i>
                    台灣 334桃園市八德區中正二街2號
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="text-lg font-bold mb-4">追蹤我們</h4>
                <div className="flex gap-3">
                  <a
                    href="#"
                    className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer"
                  >
                    <i className="ri-facebook-fill"></i>
                  </a>
                  <a
                    href="#"
                    className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer"
                  >
                    <i className="ri-line-fill"></i>
                  </a>
                  <a
                    href="#"
                    className="w-10 h-10 rounded-full border border-[#D4AF37] flex items-center justify-center hover:bg-[#D4AF37] transition-all cursor-pointer"
                  >
                    <i className="ri-instagram-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 bg-[#0D0D0D]">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-white/40">
              © 2024 東樺建築塗裝有限公司. All rights reserved.
            </div>
            <div className="flex items-center gap-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/40 hover:text-[#D4AF37] transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
